import { useAppSelector } from 'flex/utils';
import { useContext, useEffect } from 'react';
import * as Actions from 'flex/Actions';
import { ListContext } from '.';

// クラス一覧取得結果を ListContext に反映する effect component
export const ClassEffectComponent: React.FC = () => {
    const [, setList] = useContext(ListContext);
    const classSearchConnection = useAppSelector(
        (state) => state.classSearchConnection,
    );

    useEffect(() => {
        if (classSearchConnection.meta.status === Actions.statusEnum.SUCCESS) {
            if (classSearchConnection.meta.mapKey === undefined) {
                setList((prev) => ({
                    ...prev,
                    classList: classSearchConnection.payload.result.items,
                    classListItemCount:
                        classSearchConnection.payload.result.item_count,
                }));
            } else {
                setList((prev) => {
                    const mapKey = classSearchConnection.meta.mapKey!;
                    const newClassListMap = Object.assign({}, prev.classListMap, {
                        [mapKey]:
                            classSearchConnection.payload.result.items,
                    });
                    const newClassListMapItemCount = Object.assign(
                        {},
                        prev.classListMapItemCount,
                        {
                            [mapKey]:
                                classSearchConnection.payload.result.item_count,
                        },
                    );
                    return {
                        ...prev,
                        classListMap: newClassListMap,
                        classListMapItemCount: newClassListMapItemCount,
                        classListMapListCount: Object.keys(newClassListMap).length,
                    };
                });
            }
        }
    }, [classSearchConnection]); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
};
